import React, { Component } from 'react'
import PropTypes from 'prop-types'

import styles from './TestDriveBookingFlow.module.sass'

class VinLpnNumberInput extends Component {
  static propTypes = {
    country: PropTypes.string,
    pattern: PropTypes.string,
    finishedCallback: PropTypes.func,
    translations: PropTypes.object,
    requireLpn: PropTypes.bool,
  }

  state = {
    vinLpn: '',
  }

  setVinLpnNumber = (e) => {
    this.setState({ vinLpn: e.target.value })
  }

  finished = () => {
    if (!this.props.finishedCallback) return
    const payload = {
      vin_lpn: this.state.vinLpn,
    }
    this.props.finishedCallback(payload)
  }

  render() {
    return (
      <div className={styles.tradeInContainer}>
        <h3 className={styles.subheadline}>
          {this.props.translations.trade_in_question}
        </h3>
        <div className="vin-lpn-form">
          {this.props.requireLpn && (
            <div className="lpn-input-wrapper">
              <input
                type="text"
                name="vin_lpn"
                id="vin_lpn"
                className={`lpn-input unstyled country-${this.props.country}`}
                pattern={this.props.pattern}
                onChange={this.setVinLpnNumber}
              />
            </div>
          )}
          <button className="main-cta" onClick={this.finished}>
            <span>{this.props.translations.trade_in_cta}</span>
          </button>
        </div>
      </div>
    )
  }
}

export default VinLpnNumberInput
